<template>
  <Teleport to="body">
    <div v-if="isVisible" class="parameters-overlay">
      <div class="parameters-overlay-backdrop" @click="close"></div>
      <div class="parameters-overlay-content">
        <div class="parameters-overlay-header">
          <h1>{{ $t('user.parameters') }}</h1>
          <button class="close-button" @click="close">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div v-if="isLoading" class="spinner-border text-info" role="status"></div>

        <div v-else class="white-container small-padding">
          <company-parameters :propsCompany="company" @updateCompany="updateCompany"/>
          <hr class="line" style="margin-top: 3rem"/>
          <emission-unit-parameters :propsCompany="company" @updateCompany="updateCompany"/>
          <hr class="line" />
          <intensities-parameters :propsCompany="company" @updateCompany="updateCompany"/>
          <hr class="line" />
          <factors-database-parameters :propsCompany="company"/>
          <hr class="line" />
          <tagsParameters />
        </div>

        <div class="parameters-overlay-footer">
          <button class="btn primary-btn" @click="close">
            {{ $t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import instance from '../../main';
import companyParameters from './companyParameters.vue'
import emissionUnitParameters from './emissionUnitParameters.vue'
import intensitiesParameters from './intensitiesParameters.vue'
import factorsDatabaseParameters from './factorsDatabaseParameters.vue'
import tagsParameters from './tagsParameters.vue'
import eventBus from '../../eventBus'

export default {
  components: {
    companyParameters, emissionUnitParameters, intensitiesParameters, factorsDatabaseParameters, tagsParameters
  },
  data () {
    return {
      isVisible: false,
      isLoading: true,
      company: null,
      hasChanges: false
    }
  },
  mounted() {
    eventBus.on('show-parameters-overlay', this.open)
  },
  beforeUnmount() {
    eventBus.off('show-parameters-overlay', this.open)
  },
  methods: {
    open() {
      this.company = JSON.parse(localStorage.getItem('currentCompany'))
      this.isVisible = true
      this.isLoading = false
      this.hasChanges = false
      document.body.style.overflow = 'hidden'
    },
    close() {
      this.isVisible = false
      document.body.style.overflow = ''
      if (this.hasChanges) {
        eventBus.emit('parameters-updated')
      }
    },
    async updateCompany(company) {
      eventBus.emit('show-toast', {
        type: 'info',
        message: this.$t('toast.updating')
      })
      await instance.put(`/companies`, {
        company: company
      }, {
        headers : {
          "token": localStorage.getItem('token'),
          "company": localStorage.getItem('companyId')
        },
      }).then(() => {
        eventBus.emit('show-toast', {
          type: 'success',
          message: this.$t('toast.updateSuccess')
        })
        let companies = JSON.parse(localStorage.getItem('companies'))
        companies = companies.map(c => {
          if(c.id == company.id){
            return company
          }
          return c
        })
        localStorage.setItem('companies', JSON.stringify(companies))

        // Mettre à jour currentCompany avec les nouvelles données
        const currentCompanyId = localStorage.getItem('companyId')
        const currentCompany = companies.find(c => c.id == currentCompanyId)
        if (currentCompany) {
          localStorage.setItem('currentCompany', JSON.stringify(currentCompany))
          this.company = currentCompany
        }

        this.hasChanges = true
        eventBus.emit('update-sidebar-companies')
      }).catch((error) => {
        eventBus.emit('show-toast', {
          type: 'error',
          message: this.$t('toast.updateError')
        })
        console.log("Error while updating company informations")
        console.log(error)
      })
    },
  }
}
</script>

<style>
.parameters-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.parameters-overlay-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.parameters-overlay-content {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--main-bg);
  overflow-y: auto;
  padding: 1rem 4rem 2rem;
  box-sizing: border-box;
}

.parameters-overlay-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  position: sticky;
  top: 0;
  background-color: var(--main-bg);
  padding: 1rem 0;
  z-index: 1;
}

.parameters-overlay-header h1 {
  margin: 0;
}

.parameters-overlay-header .close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--main-text);
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
}

.parameters-overlay-header .close-button:hover {
  opacity: 0.7;
}

.parameters-overlay-footer {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
  margin-top: 2rem;
}
</style>
